import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
import { DocumentDraftSelfInvoiceMainSectionProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { Skeletons, StyledButton, TitledContainerInner } from "components/common";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { useDocumentDraftService, useSelfInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const SelfInvoiceMainSection: React.FC<DocumentDraftSelfInvoiceMainSectionProps> = (props) => {
  const { documentDraft } = props;

  const documentDraftService = useDocumentDraftService();
  const selfInvoiceService = useSelfInvoiceService();

  const [selfInvoice, setSelfInvoice] = React.useState<WintSuperkollAPIModel.SelfInvoice>();
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (documentDraft.entityGuid) {
      setLoading(true);
      selfInvoiceService
        .get(documentDraft.entityGuid)
        .then((res) => {
          setSelfInvoice(res);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const location = useLocation();
  const navigate = useNavigate();

  const onViewAllClick = () => {
    if (documentDraft.entityGuid) {
      navigate(UrlHelper.formatPath(`/SelfInvoice/${documentDraft.entityGuid}`), {
        state: { background: location },
      });
    }
  };

  const getHeader = () => {
    const title = `${documentDraftService.getTypeText(documentDraft.type)} `;

    if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Rejected) {
      return title.concat(
        `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Removed).toLowerCase()}`
      );
    } else if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Deleted) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.DocumentDeleted);
    } else {
      return title.concat(
        `${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Created).toLowerCase()}`
      );
    }
  };

  const getSubHeader = () => {
    let subHeader = LocalizationHelperInstance.getFormattedMessage(
      TranslationKeys.DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderText
    );

    if (
      documentDraft.entityGuid === undefined ||
      selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Unhandled
    ) {
      subHeader = subHeader.concat(
        ` ${LocalizationHelperInstance.getFormattedMessage(
          TranslationKeys.DocumentDraft.CreatedSelectionPanelSelfInvoiceHeaderSubText
        )}`
      );
    } else if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Rejected) {
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.DocumentDraft.RemovedSelectionPanelSelfInvoiceHeaderText
      );
    } else if (selfInvoice?.state === WintSuperkollAPIModel.SelfInvoiceState.Deleted) {
      return LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.DocumentDeletedDescription);
    }

    return subHeader;
  };

  return (
    <>
      {loading ? (
        <Skeletons.TitledContainerSkeleton />
      ) : (
        <TitledContainerInner header={getHeader()} subHeader={getSubHeader()} loading={loading}>
          {documentDraft.entityGuid ? (
            <Grid container direction="row" spacing={1} className={cssExports.titledContainerButtons}>
              <Grid item>
                <StyledButton size="md" onClick={onViewAllClick} secondary>
                  {`${LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.Common.View
                  )} ${documentDraftService.getTypeText(documentDraft.type).toLowerCase()}`}
                </StyledButton>
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </TitledContainerInner>
      )}
    </>
  );
};

export default SelfInvoiceMainSection;
